export default "__VITE_ASSET__Cyqwe5GM__"